import { FormattedMessage } from 'react-intl';

import type { featuresTableProps } from '@xing-com/crate-premium-projobs-shared-features-overview';
import {
  FeaturesOverview,
  usePremiumData,
} from '@xing-com/crate-premium-projobs-shared-features-overview';
import { Hero } from '@xing-com/typography';
import { Column, Grid, Row } from '@xing-com/xing-grid';

export const PremiumFeaturesOverview: React.FC = () => {
  const { data } = usePremiumData();
  const featuresTableHeaders = [
    <span key="basic" aria-hidden="true">
      Basic
    </span>,
    <span key="premium" aria-label="Premium benefits">
      Premium
    </span>,
  ];
  const featuresTable = data?.viewer?.premiumFeaturesOverview?.collection;
  if (!featuresTable || !data?.viewer?.premiumFeaturesOverview) {
    return null;
  }

  return (
    <Grid>
      <Column size={12}>
        <Row>
          <Hero>
            <FormattedMessage id={'PREMIUM_FEATURES_OVERVIEW_HEADER_BASIC'} />
          </Hero>
        </Row>
        <FeaturesOverview
          featuresTableHeaders={featuresTableHeaders}
          //eslint-disable-next-line @typescript-eslint/consistent-type-assertions
          featuresTable={featuresTable as featuresTableProps}
        />
      </Column>
      <Column size={12} sizeConfined={11} sizeXWide={9}></Column>
    </Grid>
  );
};
